/* eslint-disable camelcase */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import element_locale from 'element-ui/lib/locale/lang/cs-CZ' // default language for ElementUI is slovak
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import cz_locale from './lang/cz'
import sk_locale from './lang/sk'
import ua_locale from './lang/ua'
import VueMq from 'vue-mq'
import VueMobileDetection from 'vue-mobile-detection'

Vue.use(VueMobileDetection)

Vue.use(VueI18n)
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'cz', // set locale, zatial natvrdo czech
  messages: {cz: cz_locale, sk: sk_locale, ua: ua_locale}
})

Vue.use(Element, {
  size: 'medium', // set element-ui default size)
  locale: element_locale
})

const moment = require('moment')
require('moment/locale/cs')
Vue.use(require('vue-moment'), {
  moment
})

Vue.use(VueMq, {
  breakpoints: {
    mobile: 700,
    tablet: 900,
    laptop: 1200,
    email: 1350,
    w1500: 1500,
    w1680: 1680,
    desktop: Infinity
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js